import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum StatisticsTableSortProps {
    STORE_NAME = 'storeName',
    PRODUCT_NAME = 'productName',
    PRODUCT_COUNT = 'productCount',
    ACTIVE_SKUS = 'activeSkus',
    INVENTORY = 'stock',
    SOLD = 'sold',
    REVENUE = 'revenueTotal'
  }
  
  export interface StatisticsTableSearchProps {
    id: number
    productName: string
    storeName: string
    activeSkusMax: number
    activeSkusMin: number
    stockMax: number
    stockMin: number
    soldMin: number
    soldMax: number
    minRevenue: number
    maxRevenue: number
    storeIds: number[]
    productCountMax: number
    productCountMin: number
    addedOnPeriod: PeriodPickerProps['period']
  }